module.exports = __webpack_public_path__ + "static/media/kdb-banner.849ed89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner.png
// module id = 1279
// module chunks = 1